<div class="kiene-content-page">
    <div *ngIf="isLoading" class="kiene-loading-spinner">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <div class="kiene-table-header">
        <div>
            <button
                (click)="goBack()"
                mat-icon-button
                matTooltip="zurück"
                style="display: inline-block"
                [attr.data-cy]="'cgcgdcgd_button_1_0'"
            >
                <mat-icon color="primary" [attr.data-cy]="'cgcgdcgd_mat-icon_1_2'">arrow_back</mat-icon>
            </button>
            <h2 style="display: inline-block; margin-left: 20px">
                Unternehmensgruppe {{ companyGroup.bezeichnung }}
            </h2>
        </div>
    </div>
    <div>
        <div class="kiene-table-header">
            <mat-card style="width: 100%">
                <mat-tab-group
                    (selectedTabChange)="setSelectedTab($event)"
                    [selectedIndex]="selectedTab"
                    style="width: 100%"
                >
                    <mat-tab label="Allgemein">
                        <div style="padding-bottom: 30px">
                            <h4>Allgemein</h4>
                            <mat-form-field style="width: 40%; min-width: 250px">
                                <input
                                    [(ngModel)]="companyGroup.bezeichnung"
                                    matInput
                                    placeholder="Name der Unternehmensgruppe"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_1_1'"
                                />
                            </mat-form-field>
                            <br />
                            <mat-form-field style="width: 82%">
                                <input
                                    [(ngModel)]="companyGroup.kommentar"
                                    matInput
                                    placeholder="Kommentar"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_2_1'"
                                />
                            </mat-form-field>

                            <mat-form-field style="width: 82%">
                                <input
                                    [(ngModel)]="companyGroup.strasse"
                                    matInput
                                    placeholder="Straße"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_3_1'"
                                />
                            </mat-form-field>

                            <mat-form-field style="width: 27%; margin-right: 1%">
                                <input
                                    [(ngModel)]="companyGroup.plz"
                                    matInput
                                    placeholder="PLZ"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_4_1'"
                                />
                            </mat-form-field>

                            <mat-form-field style="width: 27%; margin-right: 1%">
                                <input
                                    [(ngModel)]="companyGroup.ort"
                                    matInput
                                    placeholder="Ort"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_5_1'"
                                />
                            </mat-form-field>

                            <mat-form-field style="width: 27%; margin-right: 1%">
                                <input
                                    [(ngModel)]="companyGroup.ortsteil"
                                    matInput
                                    placeholder="Ortsteil"
                                    type="text"
                                    [attr.data-cy]="'cgcgdcgd_input_6_1'"
                                />
                            </mat-form-field>

                            <mat-form-field style="width: 40%; margin-right: 10px">
                                <input
                                    [formControl]="emailCtrl"
                                    matInput
                                    placeholder="E-Mail Adresse"
                                    type="email"
                                    [attr.data-cy]="'cgcgdcgd_input_7_1'"
                                />
                                <span matPrefix>
                                    <mat-icon [attr.data-cy]="'cgcgdcgd_mat-icon_2_2'">email</mat-icon>&nbsp;&nbsp;
                                </span>
                                <button
                                    (click)="clearEmail()"
                                    *ngIf="emailCtrl.value"
                                    aria-label="Clear"
                                    mat-button
                                    mat-icon-button
                                    matSuffix
                                    [attr.data-cy]="'cgcgdcgd_button_2_0'"
                                >
                                    <mat-icon [attr.data-cy]="'cgcgdcgd_mat-icon_3_2'">close</mat-icon>
                                </button>
                                <mat-error *ngIf="emailCtrl.invalid">E-Mail Adresse ungültig</mat-error>
                            </mat-form-field>
                            <br />
                        </div>
                        <div *kienePermission="[1582]" style="width: 100%; text-align: right">
                            <button
                                (click)="saveCompanyGroup()"
                                *ngIf="isCreationForm"
                                color="primary"
                                mat-raised-button
                                style="margin-top: 40px"
                                [attr.data-cy]="'cgcgdcgd_button_3_0'"
                            >
                                Speichern
                            </button>
                            <button
                                (click)="saveCompanyGroup()"
                                *ngIf="!isCreationForm"
                                color="primary"
                                mat-raised-button
                                style="margin-top: 40px"
                                [attr.data-cy]="'cgcgdcgd_button_4_0'"
                            >
                                Speichern
                            </button>
                        </div>
                    </mat-tab>

                    <mat-tab label="Kunden" [disabled]="currentCompanyGroupId === 'neu'">
                        <div>
                            <h4>Zugeh&ouml;rige Kunden</h4>
                            <mat-list>
                                <mat-list-item *ngFor="let c of clients">
                                    <mat-icon [attr.data-cy]="'cgcgdcgd_mat-icon_4_2'">store</mat-icon>
                                    <a
                                        class="kiene-color"
                                        routerLink="/stammdaten/kunden/{{ c.kunde_id }}"
                                        style="padding-left: 20px"
                                        >{{ c.bezeichnung_final }} - {{ c.zusatz_final }}</a
                                    >
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </mat-tab>

                    <mat-tab *kienePermission="[3401]" label="Finanzen" [disabled]="currentCompanyGroupId === 'neu'">
                        <div>
                            <div style="width: 40%">
                                <kiene-verkaufspreis-selector
                                    (verkaufspreisSelectionChanged)="setSelectedVerkaufspreis($event)"
                                    [selectedVerkaufspreisId]="companyGroup.verkaufspreis_id"
                                ></kiene-verkaufspreis-selector>
                            </div>
                            <br />
                            <mat-form-field style="width: 40%">
                                <input
                                    [formControl]="rabattCtrl"
                                    matInput
                                    placeholder="Rabatt"
                                    type="number"
                                    [attr.data-cy]="'cgcgdcgd_input_8_1'"
                                />
                                <span matSuffix>%</span>
                            </mat-form-field>
                        </div>
                        <div *kienePermission="[1582]" style="width: 100%; text-align: right">
                            <button
                                (click)="saveCompanyGroup()"
                                *ngIf="isCreationForm"
                                color="primary"
                                mat-raised-button
                                style="margin-top: 40px"
                                [attr.data-cy]="'cgcgdcgd_button_5_0'"
                            >
                                Speichern
                            </button>
                            <button
                                (click)="saveCompanyGroupFinanzen()"
                                *ngIf="!isCreationForm"
                                color="primary"
                                mat-raised-button
                                style="margin-top: 40px"
                                [attr.data-cy]="'cgcgdcgd_button_6_0'"
                            >
                                Speichern
                            </button>
                        </div>
                    </mat-tab>

                    <mat-tab
                        *kienePermission="[1603]"
                        label="Artikelpreise"
                        [disabled]="currentCompanyGroupId === 'neu'"
                    >
                        <ng-template matTabContent>
                            <kiene-kiene-table [tableDescriptor]="artikelpreiseTableDescriptor"></kiene-kiene-table>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </div>
    </div>
</div>
